import React, { useState } from "react";

const ResumeUpload = ({ isOpen, setIsOpen }) => {
    const [file, setFile] = useState(null);

    if (!isOpen) return null; // ✅ Hide popup when isOpen is false

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    const handleRedirect = () => {
        const email = "info.cyberarcadia@gmail.com";
        const subject = encodeURIComponent("Resume Submission");
        const body = encodeURIComponent("Dear Hiring Team,\n\nPlease find my resume attached.\n\nBest Regards,");
        window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${subject}&body=${body}`, "_blank");
    };

    return (
        <div className="modal-overlay" onClick={() => setIsOpen(false)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <h2>Upload Your Resume</h2>
                <p>Attach your resume and send it to us</p>
                <label className="upload-area">
                    <input type="file" onChange={handleFileChange} accept=".pdf,.doc,.docx" hidden />
                    <span>{file ? file.name : "Drag & Drop or Click to Upload"}</span>
                </label>
                {file && <p className="file-name">📄 {file.name}</p>}
                <button className="send-btn" onClick={handleRedirect}>
                    Send Resume
                </button>
                <button className="close-btn" onClick={() => setIsOpen(false)}>Close</button>
                {file && <p className="note">📌 Don't forget to attach your file in Gmail!</p>}
            </div>
        </div>
    );
};

export default ResumeUpload;
